import React from 'react';

function Input(props) {
  return (
    <input
      className="mt-1 block w-full px-3 py-2 bg-white dark:bg-gray-900 border border-gray-300 rounded-md text-sm shadow-sm placeholder-white-400 dark:placeholder-gray-400
        focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
      {...props}
    />
  );
}

export default Input;